export const getConfig = (type: string = 'Internal') => {
  const configObj = {
    Internal: {
      title: '对内分类',
      columns: [
        {
          title: '分类编号',
          dataIndex: 'code',
          width: 200,
          ellipsis: true,
        },
        {
          title: '分类名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          render: (v: any) => <>{v ? '启用' : '停用'}</>,
        },
        {
          title: '创建人',
          dataIndex: 'createdByName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdTime',
          itemType: 'dateTime'
        },
        {
          title: '操作',
          key: 'operation',
          fixed: 'right',
          width: 180,
          render: 'actionRender',
        },
      ],
    },
    External: {
      title: '对外分类',
      columns: [
        {
          title: '分类编号',
          dataIndex: 'code',
          width: 200,
          ellipsis: true,
        },
        {
          title: '分类名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
        },
        {
          title: '关联对内分类',
          dataIndex: 'internalName',
          width: 200,
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          render: (v: any) => <>{v ? '启用' : '停用'}</>,
        },
        {
          title: '创建人',
          dataIndex: 'createdByName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdTime',
          itemType: 'dateTime'
        },
        {
          title: '操作',
          key: 'operation',
          fixed: 'right',
          width: 180,
          render: 'actionRender',
        },
      ],
    },
    Channel: {
      title: '渠道',
      columns: [
        {
          title: '渠道编号',
          dataIndex: 'code',
          width: 200,
          ellipsis: true,
        },
        {
          title: '渠道名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
        },
        {
          title: '关联级别',
          dataIndex: 'levelName',
        },
        {
          title: '状态',
          dataIndex: 'status',
          render: (v: any) => <>{v ? '启用' : '停用'}</>,
        },
        {
          title: '创建人',
          dataIndex: 'createdByName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdTime',
          itemType: 'dateTime'
        },
        {
          title: '操作',
          key: 'operation',
          fixed: 'right',
          width: 180,
          render: 'actionRender',
        },
      ],
    },
    Exposure: {
      title: '曝光渠道',
      columns: [
        {
          title: '渠道编号',
          dataIndex: 'code',
          width: 200,
          ellipsis: true,
        },
        {
          title: '渠道名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          render: (v: any) => <>{v ? '启用' : '停用'}</>,
        },
        {
          title: '创建人',
          dataIndex: 'createdByName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdTime',
          itemType: 'dateTime'
        },
        {
          title: '操作',
          key: 'operation',
          fixed: 'right',
          width: 180,
          render: 'actionRender',
        },
      ],
    },
    Solution: {
      title: '解决方案',
      columns: [
        {
          title: '分类编号',
          dataIndex: 'code',
          width: 200,
          ellipsis: true,
        },
        {
          title: '分类名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          render: (v: any) => <>{v ? '启用' : '停用'}</>,
        },
        {
          title: '创建人',
          dataIndex: 'createdByName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdTime',
          itemType: 'dateTime'
        },
        {
          title: '操作',
          key: 'operation',
          fixed: 'right',
          width: 180,
          render: 'actionRender',
        },
      ],
    },
  }
  return {
    ...configObj[type],
    tableType: 'antd',
    rowSelection: false,
    pagination: false,
    footer: [{label: '新增', type: 'primary', events: ['onClick:onAdd']}]
  }
}